import { render, staticRenderFns } from "./ProductIcons.vue?vue&type=template&id=270c4cd3&"
import script from "./ProductIcons.vue?vue&type=script&lang=js&"
export * from "./ProductIcons.vue?vue&type=script&lang=js&"
import style0 from "./ProductIcons.vue?vue&type=style&index=0&id=270c4cd3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports